<template>
  <section>
    <figure class="w-100 d-flex justify-content-center mb-5">
      <img src="/img/site/modal-error-payment.png" alt="" />
    </figure>
    <div class="d-flex flex-column justify-content-center content-center mt-1">
      <h3 class="mb-3">
        {{ $t('manageplan.component.modal.error-payment.title') }}
      </h3>
      <p class="px-5 mx-4 text-gray-500 mt-3" v-if="messageModal">
        {{ messageModal }}
        <!-- {{ $t('manageplan.component.modal.error-payment.description') }} -->
      </p>
      <CButton @click="setModal(null)" class="px-5 py-2 mt-3 btn-outline-primary">
        {{ $t('manageplan.component.modal.error-payment.link') }}
      </CButton>
    </div>
  </section>
</template>

<script>
export default {
  name: 'ModalLoadingPayment',

  methods: {
    setModal() {
      this.$store.dispatch('backOffice/steps/setModalComponent', { modalName: '', componentName: '' })
    },
  },

  computed: {
    messageModal() {
      return this.$store.state.backOffice.steps.messageModal
    },
  },
}
</script>

<style lang="scss"></style>
